<div class="auth-flow-subtext">
  <div class="header" i18n>{{ 'Set a New Password' }}</div>
  <div class="subtext" i18n>
    {{
      'Set a new password to access your account. You will have to sign back in to your users using your new password once it has been reset. '
    }}
  </div>
</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 mb-4">
  <div class="d-flex flex-column gap-2">
    <label for="email" class="form-input-label" i18n>Email</label>
    <app-email-input formControlName="email" controlId="email" />
  </div>

  <div class="d-flex flex-column gap-2">
    <label for="code" class="form-input-label" i18n>Code</label>
    <app-text-input formControlName="code" controlId="code" />
  </div>

  <div class="d-flex flex-column gap-2">
    <label for="newPassword" class="form-input-label" i18n>New Password</label>
    <app-password-input
      formControlName="newPassword"
      controlId="newPassword"
      [error]="formSubmitted && formGroup.controls.newPassword.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.newPassword.invalid"
      [customErrorMessages]="customErrorMessages.password"
      [errors]="formGroup.controls.newPassword.errors" />
    <span class="form-input-hint">{{ passwordHintText }}</span>
  </div>

  <div class="d-flex flex-column gap-2">
    <label for="confirmPassword" class="form-input-label" i18n>Confirm Password</label>
    <app-password-input
      formControlName="confirmPassword"
      controlId="confirmPassword"
      (keydown.enter)="submit()"
      [error]="formSubmitted && formGroup.controls.confirmPassword.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.confirmPassword.invalid"
      [errors]="formGroup.controls.confirmPassword.errors" />
  </div>
</form>

<app-primary-button class="w-100" [width]="'100%'" i18n (buttonClicked)="submit()">
  {{ 'Set New Password' }}
</app-primary-button>
